import { StatesObj } from 'src/app/app.models';
import { StringUtils } from './string-utils';
import { AbstractControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { QueryList } from '@angular/core';

export class FormSearchUtils {
  constructor() {}

  handleFilteredStateOption(
    filterValue: string,
    controlName: string,
    states: (StatesObj | { label: string; value: string })[],
    form: FormGroup,
    triggers: QueryList<MatAutocompleteTrigger>,
    errorKey: string[]
  ) {
    const formControl = form.get(controlName);
    filterValue =
      StringUtils.removeDiacriticsAndConvertToLowercase(filterValue);
    if (states.length === 1) {
      let isMatch: boolean;
      let option = states[0];
      if ('code' in option) {
        option = option as StatesObj;
        isMatch =
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option?.code) ||
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option?.name);
      } else {
        option = option as { label: string; value: string };
        isMatch =
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option.label) ||
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option.value);
      }
      if (isMatch) {
        this.handleSingleStateMatch(option, formControl, triggers);
      } else {
        this.handleNoStateMatch(filterValue, states, formControl, errorKey);
      }
    } else if (states.length > 1) {
      const matchingState = this.findStateMatch(states, filterValue);
      if (matchingState.length === 1) {
        const option = matchingState[0];
        this.handleSingleStateMatch(option, formControl, triggers);
      } else {
        this.handleNoStateMatch(filterValue, states, formControl, errorKey);
      }
    } else {
      this.handleNoStateMatch(filterValue, states, formControl, errorKey);
    }
  }

  findStateMatch(
    states: (StatesObj | { label: string; value: string })[],
    filterValue: string
  ): (StatesObj | { label: string; value: string })[] {
    return states.filter((state) => {
      if ('code' in state) {
        const option = state as StatesObj;
        return (
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option.code) ||
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option.name)
        );
      } else {
        const option = state as { label: string; value: string };
        return (
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option.label) ||
          filterValue ===
            StringUtils.removeDiacriticsAndConvertToLowercase(option.value)
        );
      }
    });
  }

  public handleSingleStateMatch(
    option: StatesObj | { label: string; value: string },
    formControl: AbstractControl<any | any> | null,
    triggers: any
  ): void {
    const optionCode =
      'code' in option
        ? (option as StatesObj).code
        : (option as { label: string; value: string }).value;
    formControl?.setValue(optionCode, { emitEvent: false });
    this.closePanel(triggers);
  }

  public handleNoStateMatch(
    filterValue: string,
    statesArray: (StatesObj | { label: string; value: string })[],
    formControl: AbstractControl<any | any> | null,
    errorKey: string[]
  ): void {
    if (!filterValue && statesArray.length) {
      this.setFormError(formControl, errorKey[0]);
    } else {
      this.setFormError(formControl, errorKey[1]);
    }
  }

  public setFormError(
    formControl: AbstractControl<any | any> | null,
    errorType: string
  ): void {
    formControl?.setErrors({ [errorType]: true });
  }

  private closePanel(triggers: QueryList<MatAutocompleteTrigger>) {
    triggers?.forEach((trigger: MatAutocompleteTrigger) => {
      if (trigger?.panelOpen) {
        setTimeout(() => trigger?.closePanel());
      }
    });
  }
}
